import * as React from 'react';
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { red } from "@mui/material/colors";
import Button from '@mui/material/Button';
import Rating from '@mui/material/Rating';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { Tooltip } from '@mui/material';

import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import PictureAsPdfTwoToneIcon from '@mui/icons-material/PictureAsPdfTwoTone';

// tabCollapse
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import StyleTwoToneIcon from '@mui/icons-material/StyleTwoTone';
import AutoFixHighTwoToneIcon from '@mui/icons-material/AutoFixHighTwoTone';
import AssessmentTwoToneIcon from '@mui/icons-material/AssessmentTwoTone';
import CalendarMonthTwoToneIcon from '@mui/icons-material/CalendarMonthTwoTone';
import SourceTwoToneIcon from '@mui/icons-material/SourceTwoTone';

import AdminMenuComponent from "../../../components/admin/AdminMenuComponent.js";

import CreateProductElementCard from "./CreateProductElementCard.js";

const config = require("../../../constants/constants.js")

const onHover = {
  cursor: "pointer",
  position: "absolute",
  left: "5px",
  top: "-10px",
  transform: "scale(2.7)",
};

const EditProductPageComponent = ({
  categories,
  fetchProduct,
  updateProductApiRequest,
  reduxDispatch,
  saveAttributeToCatDoc,
  imageDeleteHandler,
  uploadHandler,
  uploadImagesApiRequest,
  uploadImagesCloudinaryApiRequest
}) => {

  const navigate = useNavigate();

  const [validated, setValidated] = useState(false);
  const [product, setProduct] = useState({});
  const [updateProductResponseState, setUpdateProductResponseState] = useState({
    message: "",
    error: "",
  });

  const [attributesFromDb, setAttributesFromDb] = useState([]); // for select lists
  const [attributesTable, setAttributesTable] = useState([]); // for html table
  const [categoryChoosen, setCategoryChoosen] = useState("Choose category");
  const [products, setProducts] = useState([]);

  const [categoriaScelta, setCategoriaScelta] = useState("scegli la categoria");  // è la categoria cliccata nelTab
  const [prodottoScelto, setProdottoScelto] = useState("scegli il servizio");     // è il servizio/prodotto cliccata nelTab
  // true/false se valorizzati
  const [isCategoriaScelta, setIsCategoriaScelta] = useState(false);              // è un boleano true/false
  const [isProdottoScelto, setIsProdottoScelto] = useState(false);                // è un boleano true/false
  const [isRisorsaScelta, setIsRisorsaScelta] = useState(false);                  // è un boleano true/false
  const [isSitoScelto, setIsSitoScelto] = useState(false);                        // è un boleano true/false
  const { pageNumParam } = useParams() || 1;
  const { searchQuery } = useParams() || "";
  const [sortOption, setSortOption] = useState("");
  const [paginationLinksNumber, setPaginationLinksNumber] = useState(null);
  const [pageNum, setPageNum] = useState(null);
  const [filters, setFilters] = useState({}); // collect all filters
  const [error, setError] = useState(false);

  const [imageRemoved, setImageRemoved] = useState(false)
  const [isUploading, setIsUploading] = useState("");
  const [imageUploaded, setImageUploaded] = useState(false);

  const { id } = useParams();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [note, setNote] = useState("");
  const [noteCollapses, setNoteCollapses] = useState([]);
  const [color, setColor] = useState("");
  const [count, setCount] = useState(0);
  const [price, setPrice] = useState(0);
  const [isBookable, setIsBookable] = useState(false);
  const [bookingPrice, setBookingPrice] = useState(0);
  const [selectorIsBookable, setSelectorIsBookable] = useState(false);

  const [category, setCategory] = useState("");
  const [images, setImages] = useState([]);
  const [pdfs, setPdfs] = useState([]);
  const [collapses, setCollapses] = useState([]);

  const [linkHttpButtonName, setLinkHttpButtonName] = useState("");
  const [linkHttpButtonHelp, setLinkHttpButtonHelp] = useState("");
  const [linkHttpPath, setLinkHttpPath] = useState("");

  const [itemCollapse, setItemCollapse] = useState({});
  const [tabCollapseValues, setTabCollapseValues] = useState([]);

  const defaultNoteCollapseValues = [
    {
      id: 1,
      iconName: 'SourceTwoToneIcon',
      title: 'Contenuti dinamici',
      type: 'elenco',
      imagePath: '',
      imageTitle: '',
      elementText1: 'con accesso Admin puoi cambiare foto e scritte',
      elementText2: 'carica le foto dal tuo telefono, verranno ottimizzate in automatico',
      elementText3: 'cambia le immagini e i testi per occasioni/eventi',
      elementText4: 'gestisci e memorizza i clienti',
    },
  ]

  const defaultTabCollapseValues = [
    {
      id: 1,
      iconName: 'StyleTwoToneIcon',
      title: 'Immediato',
      type: 'immagine',
      imagePath: '/images-0001/products/aa95e564-e9e7-4399-9b2d-a2dd17dc0f3f.jpg',
      imageTitle: 'catalogo prodotti/servizi con immagini',
      elementText1: '',
      elementText2: '',
      elementText3: '',
      elementText4: '',
    },
    {
      id: 2,
      iconName: 'CalendarMonthTwoToneIcon',
      title: 'Responsive',
      type: 'testo',
      imagePath: '',
      imageTitle: '',
      elementText1: 'per tutte le devices:',
      elementText2: '• PC',
      elementText3: '• Tablet',
      elementText4: '• Smartphone',
    },
    {
      id: 3,
      iconName: 'SourceTwoToneIcon',
      title: 'Contenuti dinamici',
      type: 'elenco',
      imagePath: '',
      imageTitle: '',
      elementText1: 'con accesso Admin puoi cambiare foto e scritte',
      elementText2: 'carica le foto dal tuo telefono, verranno ottimizzate in automatico',
      elementText3: 'cambia le immagini e i testi per occasioni/eventi',
      elementText4: 'gestisci e memorizza i clienti',
    },
    {
      id: 4,
      iconName: 'AutoFixHighTwoToneIcon',
      title: 'Personalizzabile',
      type: 'testo',
      imagePath: '',
      imageTitle: '',
      elementText1: 'puoi personalizzare il tuo portale scegliendo lo stile che preferisci:',
      elementText2: '• scegli font e colore del menu',
      elementText3: '• imposta lo sfondo delle pagine',
      elementText4: '• cambia immagini e scritte quando vuoi',
    },
  ];

  const uploadProductImagesApiRequest = async (images, productId) => {

    console.log("[uploadProductImagesApiRequest]")
    console.log("[uploadProductImagesApiRequest] images=", images)
    console.log("[uploadProductImagesApiRequest] id=", productId)

    const formData = new FormData();
    Array.from(images).forEach((image) => {
      formData.append("images", image);
    });

    console.log("[uploadProductImagesApiRequest] formData=", formData)
    console.log("[uploadProductImagesApiRequest] POST /api/products/admin/upload?productId")

    const { data } = await axios.post("/api/products/admin/upload?productId=" + productId, formData);
    return data;
  };

  const uploadProductPdfApiRequest = async (pdfs, productId) => {

    console.log("[uploadProductPdfApiRequest]")
    console.log("[uploadProductPdfApiRequest] pdfs=", pdfs)
    console.log("[uploadProductPdfApiRequest] id=", productId)

    const formData = new FormData();
    Array.from(pdfs).forEach((pdf) => {
      formData.append("pdfs", pdf);
    });

    console.log("[uploadProductPdfApiRequest] formData=", formData)
    console.log("[uploadProductPdfApiRequest] POST /api/products/admin/uploadpdfs?productId")

    const { data } = await axios.post("/api/products/admin/uploadpdfs?productId=" + productId, formData);
    return data;
  };

  const handleSalva = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const formInputs = {
      name: name,
      description: description,
      note: note,
      noteCollapses: noteCollapses,
      count: count,
      color: color,
      price: price,
      isBookable: isBookable,
      bookingPrice: bookingPrice,
      category: category,
      images: images,
      pdfs: pdfs,
      collapses: collapses,
      //linkHttp: linkHttp,
      linkHttp:
      {
        buttonName: linkHttpButtonName,
        buttonHelp: linkHttpButtonHelp,
        path: linkHttpPath,
      },
      attributesTable: attributesTable,
    };

    if (selectorIsBookable) formInputs.isBookable = false;
    if (selectorIsBookable) formInputs.bookingPrice = 0;

    console.log('[handleSalva] selectorIsBookable =', selectorIsBookable);
    console.log('[handleSalva] formInputs =', formInputs);

    //if (event.currentTarget.checkValidity() === true) {
    updateProductApiRequest(id, formInputs)
      .then((data) => {
        //if (data.message === "product updated") navigate("/admin/products");
      })
      .catch((er) =>
        setUpdateProductResponseState({
          error: er.response.data.message
            ? er.response.data.message
            : er.response.data,
        })
      );
    //}
    setValidated(true);
    //window.location.assign('/admin/products')
  };

  const handleLoadImage = (event) => {
    const files = Array.from(event.target.files);
    const statusStep = 100 / files.length;

    console.log("[handleLoadImage] event.target.files=" + event.target.files);
    console.log("[handleLoadImage] files.length=" + files.length);
    console.log("[handleLoadImage] id (productId)=" + id);

    /*
    for (let i = 0; i < files.length; i++) {
      // ## controllo dimensione totale
      //
      // uploadItem(files[i]);
      // Here it guarantees that state updated correctly
      // setState(prevStep => prevStep + statusStep);
    }
    */

    setIsUploading("upload files in corso ...");
    uploadProductImagesApiRequest(event.target.files, id)
      .then(data => {
        setIsUploading("upload files completato");
        setImageUploaded(!imageUploaded);
      })
      .catch((er) => setIsUploading(er.response.data.message ? er.response.data.message : er.response.data));
    // DEBUG stacco window.location.assign
    //window.location.assign(`/admin/edit-product/${id}`)
  };

  const [namefilePdf, setNameFilePdf] = useState("");

  const handleLoadPdf = (event) => {
    const files = Array.from(event.target.files);
    const statusStep = 100 / files.length;

    console.log("[handleLoadPdf] event.target.files=" + event.target.files[0].name)
    console.log("[handleLoadPdf] files.length=" + files.length)

    for (let i = 0; i < files.length; i++) {
      // ## controllo dimensione totale
      //
      // uploadItem(files[i]);
      // Here it guarantees that state updated correctly
      // setState(prevStep => prevStep + statusStep);
    }

    setNameFilePdf(event.target.files[0].name);

    setIsUploading("upload files in corso ...");
    uploadProductPdfApiRequest(event.target.files, id)
      .then(data => {
        setIsUploading("upload files completato");
        setImageUploaded(!imageUploaded);
      })
      .catch((er) => setIsUploading(er.response.data.message ? er.response.data.message : er.response.data));
    //window.location.assign(`/admin/edit-product/${id}`)
  };

  useEffect(() => {
    fetchProduct(id)
      .then((product) => {
        setProduct(product)
        console.log(`product =`, product);
        //console.log(`linkHttp =`, product?.linkHttp);
        //console.log(`linkHttp buttonName =`, product?.linkHttp.buttonHelp);
        setName(product?.name);
        setDescription(product?.description);
        setNote(product?.note);
        setNoteCollapses(product?.noteCollapses);
        setColor(product?.color);
        setCount(product?.count);
        setPrice(product?.price);
        setIsBookable(product?.isBookable);
        setBookingPrice(product?.bookingPrice);
        setCategory(product?.category);
        setImages(product?.images);
        //setNameFilePdf(product.pdfs[0].path.substr(product.pdfs[0].path.indexOf('.pdf')-36));
        setNameFilePdf(product.pdfs[0].name);
        setPdfs(product?.pdfs);
        setCollapses(product?.collapses);
        setLinkHttpButtonName(product?.linkHttp.buttonName);
        setLinkHttpButtonHelp(product?.linkHttp.buttonHelp);
        setLinkHttpPath(product?.linkHttp.path);

        // # per inizializzare PRODUCTS con Collapses
        //setCollapses(defaultTabCollapseValues);

        // # per inizializzare la noteCollapse 
        //setNoteCollapses(defaultNoteCollapseValues);
        
        /*
        if (bookingData != null && bookingData.length>0) {
          borderStyle="4px outset #1136a0";     
        }          
        if (typeof product?.linkHttp.buttonName === "string") setLinkHttpButtonName(product?.linkHttp.buttonName);
        if (typeof product?.linkHttp.buttonHelp === "string") setLinkHttpButtonHelp(product?.linkHttp.buttonHelp);
        if (typeof product?.linkHttp.path === "string") setLinkHttpPath(product?.linkHttp.path);
        */
        //console.log(`name  =`, name);
        //console.log(`description  =`, description);
        //console.log(`isBookable  =`, isBookable);
        //console.log(`category  =`, category);
        //console.log(`images  =`, images);
        //console.log(`pdfs  =`, pdfs);
        //console.log(`linkHttp  =`, linkHttp);
      })
      .catch((er) => console.log(er));
  }, [id, imageRemoved, imageUploaded]);

  useEffect(() => {
    let categoryOfEditedProduct = categories.find(
      (item) => item.name === product.category
    );
    if (categoryOfEditedProduct) {
      const mainCategoryOfEditedProduct =
        categoryOfEditedProduct.name.split("/")[0];
      const mainCategoryOfEditedProductAllData = categories.find(
        (categoryOfEditedProduct) =>
          categoryOfEditedProduct.name === mainCategoryOfEditedProduct
      );
      if (
        mainCategoryOfEditedProductAllData &&
        mainCategoryOfEditedProductAllData.attrs.length > 0
      ) {
        setAttributesFromDb(mainCategoryOfEditedProductAllData.attrs);
      }
    }
    setCategoryChoosen(product.category);
    setAttributesTable(product.attrs);
  }, [product]);

  useEffect(() => {
    setColor(product.color);
    //console.log('color = ',category)
  }, [])

  function gotoIndietro(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();

    window.location.assign('/admin/products')
  }


  function switchIsBookableHandler(statoSelettore) {
    console.log('[switch] statoSelettore =', statoSelettore);
    setSelectorIsBookable(!selectorIsBookable);
    if (!selectorIsBookable) {
      setBookingPrice(0);
      console.log('[switchOFF] bookingPrice =', bookingPrice);
    }
    console.log('[switchOFF] selectorIsBookable =', selectorIsBookable);
    setIsBookable(statoSelettore);
  }

  const handleSelectedFile = (event) => {
    const files = Array.from(event.target.files);
    const statusStep = 100 / files.length;
    for (let i = 0; i < files.length; i++) {
      // uploadItem(files[i]);
      // Here it guarantees that state updated correctly
      // setState(prevStep => prevStep + statusStep);
    }
  };

  const handleChangeCategoria = (event) => {
    setCategoriaScelta(event.target.value);
    setCategory(event.target.value);
  };

  // INI tabCollapse

  const tabCollapsesDefColumns = [
    //valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    //  type: 'number',
    {
      field: 'id',
      headerName: 'Pos',
      headerAlign: 'center',
      align: 'center',
      width: 50,
      editable: false,
      sortable: false,
    },
    {
      field: 'iconName',
      headerName: 'icona',
      headerAlign: 'center',
      align: 'left',
      width: 170,
      editable: true,
      sortable: false,
    },
    {
      field: 'title',
      headerName: 'titolo',
      headerAlign: 'center',
      align: 'left',
      width: 150,
      editable: true,
      sortable: false,
    },
    {
      field: 'type',
      headerName: 'tipo',
      headerAlign: 'center',
      align: 'left',
      width: 80,
      editable: true,
      sortable: false,
      description: "seleziona il tipo",
    },
    {
      field: 'imagePath',
      headerName: 'imagePath',
      headerAlign: 'center',
      align: 'left',
      width: 160,
      editable: true,
      sortable: false,
      description: "carica l'immagine",
    },
    {
      field: 'imageTitle',
      headerName: 'imageTitle',
      headerAlign: 'center',
      align: 'left',
      width: 160,
      editable: true,
      sortable: false,
      description: "carica l'immagine",
    },
    {
      field: 'elementText1',
      headerName: 'elementText1',
      headerAlign: 'center',
      align: 'left',
      width: 160,
      editable: true,
      sortable: false,
    },
    {
      field: 'elementText2',
      headerName: 'elementText2',
      headerAlign: 'center',
      align: 'left',
      width: 160,
      editable: true,
      sortable: false,
    },
    {
      field: 'elementText3',
      headerName: 'elementText3',
      headerAlign: 'center',
      align: 'left',
      width: 160,
      editable: true,
      sortable: false,
    },
    {
      field: 'elementText4',
      headerName: 'elementText4',
      headerAlign: 'center',
      align: 'left',
      width: 160,
      editable: true,
      sortable: false,
    },
  ];

  /*
  iconName: {type: String },
  title: {type: String },
  type: {type: String },  // 'T' = righe di testo, "UL" = righe di testo puntate
  imagePath: {type: String },
  imageTitle: {type: String },
  elementText1: {type: String },
  elementText2: {type: String },
  elementText3: {type: String },
  elementText4: {type: String },
  */

  const handleProcessRowUpdateCollapse = (updatedRow, originalRow) => {
    // Find the index of the row that was edited
    const rowIndex = collapses.findIndex((row) => row.id === updatedRow.id);

    //console.log('[handleProcessRowUpdateCollapse] updatedRow =', updatedRow);
    //console.log('[handleProcessRowUpdateCollapse] originalRow =', originalRow);
    //console.log('[handleProcessRowUpdateCollapse] rowIndex =', rowIndex);

    // Replace the old row with the updated row
    const updatedRows = [...collapses];
    updatedRows[rowIndex] = updatedRow;

    // Update the state with the new rows
    setCollapses(updatedRows);

    // Return the updated row to update the internal state of the DataGrid
    return updatedRow;
  };

  
  const handleProcessRowUpdateNoteCollapse = (updatedRow, originalRow) => {
    // Find the index of the row that was edited
    const rowIndex = noteCollapses.findIndex((row) => row.id === updatedRow.id);

    //console.log('[handleProcessRowUpdateNoteCollapse] updatedRow =', updatedRow);
    //console.log('[handleProcessRowUpdateNoteCollapse] originalRow =', originalRow);
    //console.log('[handleProcessRowUpdateNoteCollapse] rowIndex =', rowIndex);

    // Replace the old row with the updated row
    const updatedRows = [...noteCollapses];
    updatedRows[rowIndex] = updatedRow;

    // Update the state with the new rows
    setNoteCollapses(updatedRows);

    // Return the updated row to update the internal state of the DataGrid
    return updatedRow;
  };

  // FIN tabCollapse


  return (

    <Box sx={{ flexGrow: 1 }}>

      <Grid container spacing={2}>

        <AdminMenuComponent></AdminMenuComponent>

        <Box
          paddingLeft={{ xs: 3, md: 3 }}
          paddingRight={{ xs: 3, md: 3 }}
        >

          <Breadcrumbs separator="›" aria-label="breadcrumb"
            size={{ xs: 12, md: 4 }}
            paddingTop={{ xs: 0, md: 0 }}
            paddingLeft={{ xs: 0, md: 0 }}
            paddingRight={{ xs: 1, md: 8 }}
            spacing={{ xs: 2, md: 2 }}
          >
            <Link underline="hover" color="inherit" href="/admin/welcome">
              {config.BC_ADMIN}
            </Link>
            <Link underline="hover" color="inherit" href="/admin/products">
              {config.BC_ADMIN_PRODUCTS}
            </Link>
            <Typography sx={{ color: 'text.primary' }}>{config.BC_ADMIN_PRODUCTS_EDIT}</Typography>
          </Breadcrumbs>

          <Stack
            sx={{
              flexDirection: { xs: "row", md: "row" },
              paddingTop: 2, paddingLeft: 0, paddingRight: 0,
            }}
          >

            <Typography
              sx={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
              variant="h4"
            >
              <b>Modifica prodotto</b>&nbsp;
            </Typography>
          </Stack>

          <Grid
            useFlexGap
            sx={{
              flexDirection: { xs: "column", md: "row" },
              paddingTop: 2, paddingLeft: 0, paddingRight: 0,
              flexWrap: 'wrap'
            }}
          >

            <Box
              sx={{
                flexDirection: { xs: "column", md: "column" },
              }}
            >

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 30
                }}
              />

              <Paper
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  background: '#cce0e6'
                }}
                elevation={6}
              >

                <Stack
                  useFlexGap
                  sx={{
                    flexDirection: { xs: "column", md: "row" },
                    paddingTop: 2, paddingLeft: 0, paddingRight: 0,
                    flexWrap: 'wrap'
                  }}
                >
                  <TextField id="id-name" label="Nome" variant="outlined" value={name} defaultValue={name}
                    sx={{
                      width: "45ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setName(event.target.value);
                    }}
                  />

                  <TextField id="id-description" label="Descrizione" variant="outlined" value={description} defaultValue={description}
                    sx={{
                      width: "55ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setDescription(event.target.value);
                    }}
                  />

                  <TextField id="id-note" label="Note" variant="outlined" value={note} defaultValue={note}
                    sx={{
                      width: "65ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setNote(event.target.value);
                    }}
                    multiline
                    rows={3}
                    maxRows={6}
                  />

                 <Box sx={{
                    paddingLeft: 2,
                    paddingTop: 2,
                    paddingBottom: 1,
                  }}
                  >
                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        background: '#cce0e6'
                      }}
                      elevation={1}
                    >

                      <Typography
                        sx={{
                          color: '#383737',
                          fontFamily: 'Sans-Serif',
                          fontWeight: 200,
                          fontSize: 12,
                          border: 0,
                          paddingLeft: 1
                        }}>
                        Elenco note importanti
                      </Typography>

                      {/*   tabNoteCollapse      */}

                      <Box
                        sx={{
                          //height: 280, 
                          //width: '100%'
                        }}
                      >
                        <DataGrid
                          rows={noteCollapses}
                          columns={tabCollapsesDefColumns}
                          columnHeaderHeight={40}
                          rowHeight={40}
                          hideFooter
                          processRowUpdate={handleProcessRowUpdateNoteCollapse}
                          sx={{
                            '& .MuiDataGrid-cell': {
                              fontSize: 12, 
                            },
                            '& .MuiDataGrid-editInputCell': {
                              fontSize: 12,
                            },                            
                            '& .MuiDataGrid-columnHeader':
                            {
                              backgroundColor: "#76a5b9",
                              color: "#101011",
                              border: 1,
                              //boxShadow: 2,
                              fontSize: 13,
                              fontWeight: 900,
                            },
                            '& .MuiDataGrid-cell':
                            {
                              backgroundColor: "#a8dda2",
                              color: "#1c1c1a",
                              border: 1,
                              boxShadow: 2,
                              fontSize: 12,
                              fontWeight: 300,
                            },
                            '& .MuiDataGrid-cell:hover':
                            {
                              backgroundColor: "#b0c0e5",
                              color: 'primary.main',
                              fontSize: 12,
                            },
                            '&.Mui-selected':
                            {
                              color: 'primary.main',
                              fontSize: 12,
                            },

                          }}
                          /*
                          initialState={{
                            pagination: {
                              paginationModel: {
                                pageSize: 4,
                              },
                            },
                          }}
                          pageSizeOptions={[5]}
                          checkboxSelection
                          disableRowSelectionOnClick
                          */
                        />
                      </Box>

                    </Paper>
                  </Box>                  

                  <TextField id="id-color" label="Colore" variant="outlined" value={color} defaultValue={color} type="color"
                    sx={{
                      width: "20ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setColor(event.target.value);
                    }}
                  />

                  <TextField id="id-count" label="Quantità" variant="outlined" type="number" value={count} defaultValue={count}
                    sx={{
                      width: "15ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setCount(event.target.value);
                    }}
                  />

                  <FormControl
                    sx={{
                      width: "20ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setPrice(event.target.value);
                    }}
                  >
                    <InputLabel htmlFor="outlined-adornment-amount">Prezzo</InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-amount"
                      startAdornment={<InputAdornment position="start">€</InputAdornment>}
                      label="Prezzo"
                      type="number"
                      defaultValue={price}
                      value={price}
                    />
                  </FormControl>

                  <Box sx={{
                    paddingLeft: 2,
                    paddingTop: 2
                  }}
                  >

                    <FormControl
                      style={{
                        width: "40ch",
                        p: { xs: 1, md: 1 },
                        m: { xs: 1, md: 1 },
                      }}
                    >
                      <InputLabel id="sel-categoria">Tipo prodotto</InputLabel>
                      <Select
                        labelId="sel-categoria"
                        id="id-sel-categoria"
                        value={category}
                        label="Tipo prodotto"
                        onChange={handleChangeCategoria}
                      >
                        {categories.map(category => {
                          return (
                            <MenuItem key={category.name} value={category.name}>
                              {category.name}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>
                  </Box>

                  <Box sx={{
                    paddingLeft: 2,
                    paddingTop: 0
                  }}
                  >
                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        //background: 'rgb(191, 229, 236)',
                        background: '#f2e5c2'
                      }}
                      elevation={1}
                    >

                      <TextField id="id-linkHttpName" label="linkHttp Pulsante" variant="outlined" value={linkHttpButtonName} defaultValue={linkHttpButtonName}
                        sx={{
                          width: "55ch",
                          p: { xs: 1, md: 1 },
                          m: { xs: 1, md: 0 },
                        }}
                        onChange={(event) => {
                          setLinkHttpButtonName(event.target.value);
                        }}
                      />

                      <TextField id="id-linkHttpHelp" label="linkHttp Help" variant="outlined" value={linkHttpButtonHelp} defaultValue={linkHttpButtonHelp}
                        sx={{
                          width: "55ch",
                          p: { xs: 1, md: 1 },
                          m: { xs: 1, md: 0 },
                        }}
                        onChange={(event) => {
                          setLinkHttpButtonHelp(event.target.value);
                        }}
                      />

                      <TextField id="id-linkHttpWww" label="linkHttp" variant="outlined" value={linkHttpPath} defaultValue={linkHttpPath}
                        sx={{
                          width: "55ch",
                          p: { xs: 1, md: 1 },
                          m: { xs: 1, md: 0 },
                        }}
                        onChange={(event) => {
                          setLinkHttpPath(event.target.value);
                        }}
                      />

                    </Paper>
                  </Box>

                  <Box sx={{
                    paddingLeft: 2,
                    paddingTop: 2
                  }}
                  >
                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        //background: 'rgb(191, 229, 236)',
                        background: '#f2e5c2'
                      }}
                      elevation={1}
                    >

                      <Grid container
                        sx={{
                          paddingTop: 1, paddingBottom: 1, paddingLeft: 0, paddingRight: 0,
                          marginTopTop: 1, marginBottom: 1, marginLeft: 1, marginRight: 1,
                          //p: { xs: 1, md: 1 },
                          //m: { xs: 2, md: 2 },
                        }}
                      >

                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="small"
                          component="label"
                          fullWidth
                          endIcon={<PictureAsPdfTwoToneIcon />}
                          sx={{
                            width: "20ch",
                            //height: "8ch",
                            //borderRadius: 1,
                            borderRadius: 4,
                            backgroundColor: "#141688",
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          }}
                        >

                          <Stack
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                          >
                            <Typography
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                                color: 'white',
                                fontFamily: 'Roboto',
                                textTransform: 'none',
                                fontSize: 16,
                              }}
                            >
                              carica pdf
                            </Typography>
                          </Stack>
                          <input type="file" onChange={handleLoadPdf} hidden accept=".pdf" />
                        </Button>

                        <TextField id="id-pdf" label="file per il download" variant="outlined" value={namefilePdf}
                          sx={{
                            width: "45ch",
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 0.5, paddingRight: 0,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                          onChange={(event) => {
                            //setTitle(event.target.value);
                          }}
                        />

                      </Grid>

                    </Paper>
                  </Box>

                  <Box sx={{
                    paddingLeft: 2,
                    paddingTop: 2
                  }}
                  >
                    <Paper
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        background: '#cce0e6'
                      }}
                      elevation={1}
                    >

                      {/*   tabCollapse    */}

                      <Typography
                        sx={{
                          color: '#383737',
                          fontFamily: 'Sans-Serif',
                          fontWeight: 200,
                          fontSize: 12,
                          border: 0,
                          paddingLeft: 1
                        }}>
                        Contenuti collapse a scomparsa
                      </Typography>

                      <Box
                        sx={{
                          //height: 280, 
                          //width: '100%'
                        }}
                      >
                        <DataGrid
                          rows={collapses}
                          columns={tabCollapsesDefColumns}
                          columnHeaderHeight={40}
                          rowHeight={40}
                          hideFooter
                          processRowUpdate={handleProcessRowUpdateCollapse}
                          /*
                          sx={{
                            boxShadow: 2,
                            border: 2,
                            borderColor: 'primary.light',
                            background: '#e6e7ed',
                            '& .MuiDataGrid-cell:hover': { background:'#82e19d', color: '#000000',},
                          }}
                          */
                          sx={{
                            '& .MuiDataGrid-cell': {
                              fontSize: 12, 
                            },
                            '& .MuiDataGrid-editInputCell': {
                              fontSize: 12,
                            },                            
                            '& .MuiDataGrid-columnHeader':
                            {
                              backgroundColor: "#76a5b9",
                              color: "#101011",
                              border: 1,
                              //boxShadow: 2,
                              fontSize: 13,
                              fontWeight: 900,
                            },
                            '& .MuiDataGrid-cell':
                            {
                              backgroundColor: "#a8dda2",
                              color: "#1c1c1a",
                              border: 1,
                              boxShadow: 2,
                              fontSize: 12,
                              fontWeight: 300,
                            },
                            '& .MuiDataGrid-cell:hover':
                            {
                              backgroundColor: "#b0c0e5",
                              color: 'primary.main',
                              fontSize: 12,
                            },
                            '&.Mui-selected':
                            {
                              color: 'primary.main',
                              fontSize: 12,
                            },

                          }}
                          /*
                          initialState={{
                            pagination: {
                              paginationModel: {
                                pageSize: 4,
                              },
                            },
                          }}
                          pageSizeOptions={[5]}
                          checkboxSelection
                          disableRowSelectionOnClick
                          */
                        />
                      </Box>

                    </Paper>
                  </Box>

                </Stack>

                <Stack
                  sx={{
                    flexDirection: { xs: "row", md: "row" },
                    paddingTop: 2, paddingLeft: 2, paddingRight: 0,
                  }}
                >

                  <FormControlLabel
                    control={<Switch defaultChecked />}
                    checked={isBookable}
                    //onChange={switchIsBookableHandler}
                    onChange={(event) => {
                      switchIsBookableHandler(event.target.checked);
                    }}
                    label="Prenotabile"
                    sx={{
                      paddingTop: 0, paddingLeft: 4, paddingRight: 0,
                    }}
                  />

                  {isBookable &&

                    <Stack
                      sx={{
                        flexDirection: { xs: "row", md: "row" },
                        paddingTop: 2, paddingLeft: 0, paddingRight: 0,
                      }}
                    >

                      <FormControl
                        sx={{ m: 0, paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
                        style={{
                          width: "20ch",
                        }}
                        onChange={(event) => {
                          setBookingPrice(event.target.value);
                        }}
                      >
                        <InputLabel htmlFor="outlined-adornment-amount">Importo prenotazione</InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-amount"
                          startAdornment={<InputAdornment position="start">€</InputAdornment>}
                          label="Importo prenotazione"
                          type="number"
                          defaultValue={bookingPrice}
                          value={bookingPrice}
                        />
                      </FormControl>

                    </Stack>
                  }

                </Stack>

                <Stack
                  sx={{
                    paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    display: 'flex',
                    flexDirection: { xs: "row", md: "row" },
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >

                  <Button
                    type="button"
                    variant="contained"
                    color="warning"
                    onClick={(e) => { gotoIndietro(e); }}
                    sx={{
                      width: "12ch",
                      p: 1,
                      m: 1,
                    }}
                  >
                    Indietro
                  </Button>

                  <Button
                    variant="contained"
                    type="submit"
                    color="success"
                    onClick={handleSalva}
                    sx={{
                      width: "12ch",
                      p: 1,
                      m: 1,
                    }}
                  >
                    Salva
                  </Button>
                </Stack>

                <Box
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    height: 20
                  }}
                />

              </Paper>

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 30
                }}
              />

              <Paper
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  background: '#cce0e6'

                }}
                elevation={6}
              >

                <Box
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  }}
                >

                  <Stack
                    sx={{
                      paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      display: 'flex',
                      flexDirection: { xs: "row", md: "row" },
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >

                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      size="small"
                      component="label"
                      fullWidth
                      sx={{
                        width: "20ch",
                        p: 1,
                        m: 1,
                      }}
                    >
                      Carica immagine
                      <input type="file" onChange={handleLoadImage} hidden accept=".jpg" />
                    </Button>

                    <Typography variant="h6" color="navy"
                      sx={{
                        width: "20ch",
                        p: 1,
                        m: 1,
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                      }}
                    >
                      {images.length} immagini caricate
                    </Typography>

                    <Typography variant="h9" color="black"
                      sx={{
                        width: "50ch",
                        p: 1,
                        m: 1,
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                      }}
                    >
                      puoi modificare titoli e info
                    </Typography>

                  </Stack>

                  <Stack
                    sx={{
                      flexDirection: { xs: "row", md: "row" },
                      paddingTop: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 1,
                      position: "center", overflowX: "scroll",
                      '@media (min-width: 600px)': { width: '1400px' },
                      '!@media (min-width: 600px)': { width: '500px' },
                    }}
                  >

                    {images.map((image, idx) => (

                      <CreateProductElementCard key={idx} imagePath={image.path} idx={idx} pageId={id} nameImage={image.name} titleImage={image.title} subTitleImage={image.subTitle} pageAll={product} />

                    ))}

                  </Stack>

                </Box>

              </Paper>

              <Box
                sx={{
                  paddingTop: 4, paddingBottom: 0, paddingLeft: 0, paddingRight: 0
                }}
              />

            </Box>

          </Grid>

        </Box>

      </Grid>

    </Box>

  );
};

export default EditProductPageComponent;
